import { container } from '../../../DataDomain';
import { INotificationsRepository } from '../../repositories/interfaces/iNotificationsRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IValidateVOCTokenUseCase {
    execute(token: string, apiToken: { [key: string]: string }): Promise<any['data']>;
}

export class ValidateVOCTokenUseCase implements IValidateVOCTokenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get notificationsRepo(): INotificationsRepository {
        return container.resolve<INotificationsRepository>(DI.REPOSITORIES.INotificationsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(token: string, apiToken: { [key: string]: string }): Promise<any['data']> {
        const response = await this.notificationsRepo.validateVOCToken(token, apiToken);
        return response.data;
    }
}
